import { Link } from 'react-router-dom'
import { ArrowRight, FileText, Github, Linkedin } from 'lucide-react'
import { personalInfo } from '@/data/personal'
import { Button } from '@/components/ui/button'
import { trackEvent } from '@/lib/analytics'

export function HeroSection() {
  const { contact } = personalInfo
  return (
    <section className="container flex flex-col items-start gap-6 py-20 md:py-28">
      <h1 className="max-w-3xl text-4xl font-extrabold tracking-tight sm:text-5xl md:text-6xl">
        Hi, I&rsquo;m Chris.
      </h1>
      <p className="text-lg font-medium text-primary/90 sm:text-xl">
        {personalInfo.title}
      </p>
      <p className="max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
        {personalInfo.bio}
      </p>
      <div className="flex flex-wrap items-center gap-3 pt-2">
        <Button asChild>
          <Link to="/projects">
            View Projects
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Button>
        <Button asChild variant="outline">
          <Link to="/resume">
            <FileText className="h-4 w-4" />
            Resume
          </Link>
        </Button>
        <Button asChild variant="ghost" size="icon" aria-label="GitHub">
          <a
            href={contact.github}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackEvent('social_click', { platform: 'github', location: 'hero' })}
          >
            <Github className="h-4 w-4" />
          </a>
        </Button>
        <Button asChild variant="ghost" size="icon" aria-label="LinkedIn">
          <a
            href={contact.linkedin}
            target="_blank"
            rel="noreferrer"
            onClick={() => trackEvent('social_click', { platform: 'linkedin', location: 'hero' })}
          >
            <Linkedin className="h-4 w-4" />
          </a>
        </Button>
      </div>
    </section>
  )
}
